import type { Kitchen } from '@rta/rta-blueprint-library';

export type HasLevelingLegsParams = {
	kitchen: Kitchen;
};

export const LEVELING_LEGS_SKU = 'Leveling-Legs';

export const LEVELING_LEGS_PANEL_NOTE = 'MFG: Add leveling legs at the bottom of each panel';

export const hasLevelingLegs = (params: HasLevelingLegsParams): boolean => {
	const { kitchen } = params;
	const target = LEVELING_LEGS_SKU.toLowerCase();

	return (kitchen.accessories?.children ?? []).some((accessory) => (accessory.sku ?? '').toLowerCase() === target);
};
